import authorizationHeader from '#shared/utils/authorizationHeader';
export const getAltText = async (id, filename) => {
  const strapiBackendURL = strapi?.backendURL.length ? strapi.backendURL : window.location.origin;
  const fetchAltText = await fetch(`${strapi ? strapiBackendURL : ''}/wysiwyg/get-alt-text?id=${id}`, {
    headers: {
      ...authorizationHeader
    }
  });
  const widenAltText = await fetchAltText.text();
  return widenAltText ? widenAltText : filename;
};